
<google-map
  width="100%"
  height="50vh"
  [center]="center"
  [zoom]="zoom"
  [mapTypeId]="mapTypeId"
  style="border-radius:10px;"
  >
  @for (markerPosition of markerPositions; track markerPosition) {
    <map-marker
      [position]="markerPosition"
      [options]="markerOptions">
    </map-marker>
  }
</google-map>